import { ComparateurFunnel } from '../../../components/tools/ComparateurFunnel';
import { AudienceToolHero } from '../../../components/blocks/AudienceToolHero';
import { getAudienceToolContent } from '../../../config/audience-tool-content';
import { BreadcrumbListLd } from '../../../components/seo/jsonld/BreadcrumbList';

const content = getAudienceToolContent('collectivites', 'comparateur-energie')!;

export default function CollectivitesComparateurEnergiePage() {
  return (
    <>
      <AudienceToolHero
        content={content}
        backHref="/collectivites"
        backLabel="Espace collectivités"
        duration="3 min"
      >
        <ComparateurFunnel lockedAudience="collectivites" />
      </AudienceToolHero>

      <BreadcrumbListLd
        items={[
          { name: 'Accueil', url: 'https://solutionecofrance.fr/' },
          { name: 'Espace collectivités', url: 'https://solutionecofrance.fr/collectivites' },
          { name: 'Comparateur énergie', url: 'https://solutionecofrance.fr/collectivites/comparateur-energie' },
        ]}
      />
    </>
  );
}
